import { createElement as rc } from 'react';
import { StyleSheetManager as _StyleSheetManager } from 'styled-components';
import isPropValid from '@emotion/is-prop-valid';

export default function StyleSheetManager(props) {
    // prettier-ignore
    return rc(_StyleSheetManager, { shouldForwardProp, ...props }, props.children);
}

function shouldForwardProp(propName, target) {
    if (typeof target === 'string') {
        // For HTML elements, forward the prop if it is a valid HTML attribute
        return isPropValid(propName);
    }
    // For other elements, forward all props
    return true;
}
